export default "__VITE_ASSET__LYDwJMME__"